<template>
  <FormModal
    :value="value"
    :title="title"
    :subtitle="subtitle"
    :valid="valid"
    :loading="loading"
    v-bind="$attrs"
    @submit="submit"
    @input="input"
    @validate="validate"
  >
    <slot />
    <slot slot="actions" name="actions" />
    <v-btn slot="actions" :disabled="!valid" color="primary" :loading="loading" type="submit">{{ action }}</v-btn>
    <template #activator="props">
      <slot v-bind="props" name="activator" />
    </template>
  </FormModal>
</template>

<script>
export default {
  name: 'FormAddModal',
  inheritAttrs: false,
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: () => '',
    },
    action: {
      type: String,
      default() {
        return this.$t('Save')
      },
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      show: false,
      valid: false,
    }
  },
  methods: {
    submit() {
      this.$emit('submit')
    },
    validate(v) {
      this.valid = v
      this.$emit('update:valid', this.valid)
    },
    input(v) {
      this.$emit('input', v)
    },
  },
}
</script>
